import axios from 'axios'
import { OFFER_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getOffers(page, filter, show_expired_flag) {

    const params = {
        page,
        filter,
        show_expired_flag
    }

    return axios.get(OFFER_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function getOffer(id) {
    const url = `${OFFER_URL}/${id}`
    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function newOffer(offer) {


    return axios.post(OFFER_URL, offer, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function uploadImage(id, image) {
    let data = new FormData();
    data.append('imageFile', image);

    const url = `${OFFER_URL}/${id}/image`

    return axios.put(url, data, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })


}
export function deleteOffer(id) {
    const url = `${OFFER_URL}/${id}`
    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}
export function deleteImage(id) {
    const url = `${OFFER_URL}/${id}/image`

    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function updateOffer(id, offer) {
    const url = `${OFFER_URL}/${id}`

    return axios.put(url, offer, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })

}


// WEBPACK FOOTER //
// ./src/service/offer.js